import { Moment } from 'moment';
import { SearchRule } from './search-rule';
import { SystemUser } from './system-user';

export class SavedSearch {

    constructor(
        public name: string,
        public searchRules: SearchRule[],
        public created: Moment | null,
        public createdBy: SystemUser | null,
        public lastModified: Moment | null,
        public lastModifiedBy: SystemUser | null,
        public isPrivate: boolean,
        public isFavorite: boolean,
        public id?: number
    ){}
}
